/*
* Copyright (C) Regione Lombardia
*/
export const CoreAppConfigs = {
    NAME_DESKTOP: 'Opere di Difesa del Suolo',
    NAME_MOBILE: 'Opere di Difesa del Suolo',
    VERSION: 'versione 1.4.0'
};
